import { Field as FormikTextarea, useField, useFormikContext } from "formik";
import { Field } from "@design-system/Field/Field";
import { TextArea } from "@design-system/TextArea/TextArea";
import { flattenFormError, shouldShowFieldError } from "@helpers/form";

export const NoteTextarea = ({
    textareaRef,
    handleFocus,
    handleBlur,
    handleKeyDown,
    noteTextareaClass,
}: {
    textareaRef: React.RefObject<HTMLTextAreaElement | null>;
    handleFocus: () => void;
    handleBlur: () => void;
    handleKeyDown: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
    noteTextareaClass: string;
}) => {
    const { submitCount } = useFormikContext();
    const [, meta] = useField<string>("value");
    const isInvalid = shouldShowFieldError({
        error: meta.error,
        touched: meta.touched,
        submitCount,
    });
    const error =
        isInvalid && meta.error !== undefined
            ? flattenFormError(meta.error)
            : undefined;

    return (
        <Field.Root invalid={isInvalid}>
            <FormikTextarea
                as={TextArea}
                name="value"
                size="xl"
                rows={4}
                aria-label="Memo"
                placeholder="Add memo..."
                className={noteTextareaClass}
                ref={textareaRef}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
            />
            {error !== undefined && <Field.Error match>{error}</Field.Error>}
        </Field.Root>
    );
};
